module.exports = __webpack_public_path__ + "static/happypatient-12a62c69bc09d8e834cb795ba5714c63.jpg";